import { AxiosPromise } from 'axios';
import { client }       from '@/service/client';

export function rateCheckerConfiguration(): AxiosPromise {
  return client.get('/rate-checker/configuration');
}

export function dataSource(): AxiosPromise {
  return client.get('/hub-column-values/COMPSET/dataSource');
}

export function saveRateCheckerConfiguration(payload: { brandDataSource: string; sources: Array<string> }): AxiosPromise {
  return client.put('/rate-checker/configuration', payload);
}

export function checkRateChecker(): AxiosPromise {
  return client.get('/rate-checker/availability');
}
